var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobilephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 63.063 3 c 1.157 0 2.098 0.941 2.098 2.098 v 79.803 c 0 1.157 -0.941 2.098 -2.098 2.098 H 26.937 c -1.157 0 -2.098 -0.941 -2.098 -2.098 V 5.098 C 24.839 3.941 25.78 3 26.937 3 H 63.063 M 63.063 0 H 26.937 c -2.816 0 -5.098 2.283 -5.098 5.098 v 79.803 c 0 2.816 2.283 5.098 5.098 5.098 h 36.126 c 2.816 0 5.098 -2.283 5.098 -5.098 V 5.098 C 68.161 2.283 65.879 0 63.063 0 L 63.063 0 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.176 1.992 c 0 2.824 1.857 5.134 4.126 5.134 h 17.396 c 2.269 0 4.126 -2.31 4.126 -5.134 H 32.176 z M 47.862 4.5 h -9.466 c -0.276 0 -0.5 -0.224 -0.5 -0.5 s 0.224 -0.5 0.5 -0.5 h 9.466 c 0.276 0 0.5 0.224 0.5 0.5 S 48.139 4.5 47.862 4.5 z M 50.908 4.696 c -0.384 0 -0.696 -0.312 -0.696 -0.696 s 0.312 -0.696 0.696 -0.696 S 51.604 3.616 51.604 4 S 51.292 4.696 50.908 4.696 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilephone);
export default __webpack_public_path__ + "static/media/mobilephone.0a0dbf33589a336e18110f08f152a2f5.svg";
export { ForwardRef as ReactComponent };